import type { CardProps } from "./Card";
import { Card } from "./Card";

export interface AccessGroupCardProps extends CardProps {}

// TODO: Move `app/javascript/react/components/Modals/AdminMemberEditModal/AccessTab/AccessOverview/ContentAccessStateTable.tsx` to `@circle-react-shared/AccessRegistry/AccessGroupCard/ContentAccessStateTable.tsx`
export const AccessGroupCard = Object.assign(Card, {});
